import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SuccessLoadMore extends ThemeComponent {
    @Prop({ default: 2 }) size!: number;

    @Ref() loadMoreButton!: HTMLButtonElement | null;

    private successStories!: HTMLDivElement | null;
    private storyCard!: NodeListOf<HTMLElement> | null;
    private availableCards = 0;

    private currentIndex = 2;
    private itemsPerLoad = 2;

    constructor() {
        super();

        this.successStories = document.querySelector('[data-ref="successStories"]');
        this.storyCard = document.querySelectorAll('.js-story-card');
    }

    init() {
        this.availableCards = this.storyCard?.length || 0;

        /**
         * SuccessFilters dispatches 2 events to update this component
        */
        document.addEventListener('successCardsFiltered', () => {
            this.updateAfterFilter();
        });

        document.addEventListener('successCardsReset', () => {
            this.resetLoadMoreButton();
        });

        if (this.loadMoreButton) {
            this.$listen(this.loadMoreButton, 'click', () => {
                this.loadMoreCards();
            });
        }
    }

    /**
     * Display addtional cards based on the existing display
     * Variables, eg: this.availableCards and this.currentIndex are updated
     * in other functions which factor in filtering
     */
    loadMoreCards() {
        if (!this.loadMoreButton || !this.storyCard) { return; }

        if (this.currentIndex < this.availableCards) {
            const cardsToShow = Array.from(this.storyCard)
                .slice(this.currentIndex, this.currentIndex + this.itemsPerLoad);

            for (const card of cardsToShow) {
                card.classList.add('is-active');
            }

            this.currentIndex += this.itemsPerLoad;
            this.loadMoreButton.setAttribute('data-loaded', this.currentIndex.toString());

            this.toggleLoadMoreButton();
        }
    }

    /**
     * Toggle visibility of 'see more results' button depending on availability of cards
     * and cards already shown to the user
     */
    toggleLoadMoreButton() {
        if (this.currentIndex >= this.availableCards) {
            this.classList.add('visually-hidden');
        } else {
            this.classList.remove('visually-hidden');
        }
    }

    /**
     * Update available cards with filters applied
     */
    updateAfterFilter() {
        if (!this.storyCard) { return; }

        const filteredCards = Array.from(this.storyCard).filter(function(item) {
            return item.dataset.filtered === 'true';
        });

        this.availableCards = filteredCards.length;
        this.isOdd(this.availableCards) ? this.itemsPerLoad = 1 : this.itemsPerLoad = 2;
        this.toggleLoadMoreButton();
    }

    /**
     * Reset the load more variables before filters were enabled
     */
    resetLoadMoreButton() {
        this.successStories?.classList.remove('visually-hidden');
        this.classList.remove('visually-hidden');
        this.availableCards = this.storyCard?.length || 0;
        this.itemsPerLoad = 2;
        this.currentIndex = 2;
    }

    /**
     * If available cards are an odd number then items per load is set to 1 from 2
     * @param x - number
     * @returns boolean
     */
    isOdd(x: number) { return (x % 2) != 0; }
}

